/*! simple number format */
function number_format(number, decimals, dec_point, thousands_sep) {
  decimals = decimals || 0;
  dec_point = dec_point || '.';
  thousands_sep = thousands_sep || ',';
  
  var dec_offset = Math.pow(10, decimals);
	var neg = number < 0;
  number = (Math.round(Math.abs(number) * dec_offset) / dec_offset).toString().split('.');

  return (neg ? '-' : '') + number[0].split('').reverse().join('')
    .replace(/([0-9]{3})/g, '$1' + thousands_sep)
    .split('').reverse().join('')
    + (number[1] ? dec_point + number[1] : '');
}
